import { render, staticRenderFns } from "./quickSelect.vue?vue&type=template&id=f2141572&"
import script from "./quickSelect.vue?vue&type=script&lang=js&"
export * from "./quickSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports